module.exports = "/img/s2o_sponsor.png?0ae17378c224ee4126e87603891382e6";